<template>
  <div
    class="modal-wrap"
    :style="modalStyle"
    @click="hide"
  >
    <div class="modal">
      <div
        v-if="options.logos"
        class="modal__logo"
      >
        <img
          :src="options.logos[0]"
          :srcset="`${options.logos[1]}, ${options.logos[2]}`"
        >
      </div>

      <div
        v-if="options.title"
        class="modal__title"
      >
        {{ $t(options.title) }}
      </div>

      <div
        v-if="options.description"
        class="modal__description"
      >
        {{ $t(options.description) }}
      </div>

      <slot />

      <styledLink
        class="flow-redirect-component__cancel "
        @click="hide"
      >{{ $t('come_back') }}</styledLink>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PerfectScrollbar from "perfect-scrollbar";
import styled from 'vue-styled-components';

const styledLink = styled('a', {})`
    &:hover {
      color: ${props => props.theme.primary};
    }
`;

export default {
  components : {
    styledLink,
  },

  props: {
    options: {
      type: Object,
      required: true
    }
  },

  computed: {
    modalStyle() {
      return {
        left: "unset",
        overflow: "hidden"
      };
    }
  },

  methods: {
    hide() {
      this.$bus.$emit(`${this.options.callbackType}Toggle`, false);
    }
  }
};
</script>
